export default "__VITE_ASSET__CyoHw3v6__"